export const MediumDesktopScreen = 'screen and (max-width: 1830px)';
export const SecondSmallDesktopScreen = 'screen and (max-width: 1280px)';
export const SmallDesktopScreen = 'screen and (max-width: 1024px)';
export const LargeMobileScreen = 'screen and (max-width: 962px)';
export const SmallScreen = 'screen and (max-width: 768px)';
export const MobileScreen = 'screen and (max-width: 480px)';

export const MediumDesktopScreenAndLarger = 'screen and (min-width: 1830px)';
export const SmallDesktopScreenAndLarger = 'screen and (min-width: 1024px)';
export const LargeMobileScreenAndLarger = 'screen and (min-width: 962px)';
export const SmallScreenAndLarger = 'screen and (min-width: 768px)';
export const MobileScreenAndLarger = 'screen and (min-width: 480px)';
